/**
 * Destination-based shipping estimates for the cart page.
 * Egypt is the fixed destination. Governorate fees are supplied by the
 * theme settings and are shown immediately; Shopify's configured rates remain
 * the source of truth for the final checkout charge.
 */
(function () {
  var estimator = document.querySelector('[data-shipping-estimator]');
  if (!estimator) return;

  var form = estimator.querySelector('[data-shipping-form]');
  var country = estimator.querySelector('[data-shipping-country]');
  var province = estimator.querySelector('[data-shipping-province]');
  var zip = estimator.querySelector('[data-shipping-zip]');
  var submit = estimator.querySelector('[data-shipping-submit]');
  var message = estimator.querySelector('[data-shipping-message]');
  var selectedFee = estimator.querySelector('[data-shipping-selected-fee]');
  var results = estimator.querySelector('[data-shipping-results]');
  var copy = (window.theme && window.theme.cartCopy && window.theme.cartCopy.shipping) || {};

  function rootUrl() {
    var root = (window.theme && window.theme.routesRoot) || estimator.getAttribute('data-shipping-root') || '/';
    root = String(root);
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function setBusy(isBusy) {
    submit.disabled = isBusy;
    submit.textContent = isBusy ? (copy.calculating || 'Calculating…') : (copy.calculate || 'Calculate shipping');
  }

  function setMessage(text, type) {
    message.textContent = text || '';
    message.className = 'cart-shipping-estimator__message' + (type ? ' cart-shipping-estimator__message--' + type : '');
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function formatMoney(decimalPrice) {
    var cents = Math.round(parseFloat(decimalPrice || '0') * 100);
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{.*?\}\}/, amount);
  }

  function addressParams() {
    var params = new URLSearchParams();
    params.set('shipping_address[country]', country.value);
    if (province.value.trim()) params.set('shipping_address[province]', province.value.trim());
    if (zip.value.trim()) params.set('shipping_address[zip]', zip.value.trim());
    return params;
  }

  function selectedProvinceOption() {
    return province.options[province.selectedIndex];
  }

  function selectedFeeValue() {
    var option = selectedProvinceOption();
    var fee = option && option.getAttribute('data-shipping-fee');
    return fee === null || fee === '' ? null : parseFloat(fee);
  }

  function showSelectedFee() {
    var fee = selectedFeeValue();
    if (fee === null || Number.isNaN(fee)) {
      selectedFee.hidden = true;
      selectedFee.textContent = '';
      return;
    }

    selectedFee.hidden = false;
    selectedFee.textContent = (copy.governorateFee || 'Delivery fee for this governorate:') + ' ' + formatMoney(fee);
  }

  function renderRates(data) {
    var rates = data && Array.isArray(data.shipping_rates) ? data.shipping_rates : [];
    if (!rates.length) {
      setMessage(copy.unavailable || 'No shipping methods are available for this destination.', 'error');
      results.innerHTML = '';
      return;
    }

    // Once Shopify returns a configured checkout rate, use that as the final
    // estimate and hide the theme's governorate default so shoppers never see
    // two competing delivery prices.
    selectedFee.hidden = true;
    setMessage(copy.estimated || 'Estimated shipping methods for this destination.', 'success');
    results.innerHTML = rates.map(function (rate) {
      var price = parseFloat(rate.price || '0') === 0 ? (copy.free || 'Free') : formatMoney(rate.price);
      return '<div class="cart-shipping-estimator__rate"><span>' + escapeHtml(rate.name || 'Shipping') + '</span><strong>' + escapeHtml(price) + '</strong></div>';
    }).join('');
  }

  function getRates(params) {
    return fetch(rootUrl() + 'cart/async_shipping_rates.json?' + params.toString(), {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('shipping_rates_' + response.status);
      return response.json();
    });
  }

  function waitForRates(params, attempts) {
    return getRates(params).then(function (data) {
      if (data) return data;
      if (attempts <= 0) return { shipping_rates: [] };
      return new Promise(function (resolve) {
        window.setTimeout(function () {
          resolve(waitForRates(params, attempts - 1));
        }, 600);
      });
    });
  }

  submit.addEventListener('click', function () {
    if (!province.value.trim()) {
      setMessage(copy.required || 'Choose a governorate to calculate shipping.', 'error');
      province.focus();
      return;
    }

    var params = addressParams();
    setBusy(true);
    setMessage('', '');
    results.innerHTML = '';

    fetch(rootUrl() + 'cart/prepare_shipping_rates.json?' + params.toString(), {
      method: 'POST',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok && response.status !== 202) throw new Error('prepare_shipping_rates_' + response.status);
      return waitForRates(params, 10);
    }).then(renderRates).catch(function () {
      setMessage(copy.error || 'We could not calculate shipping right now. Please try again at checkout.', 'error');
      results.innerHTML = '';
    }).finally(function () {
      setBusy(false);
    });
  });

  province.addEventListener('change', function () {
    setMessage('', '');
    results.innerHTML = '';
    showSelectedFee();
  });

  showSelectedFee();
})();
